<div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
  style="top: 50px;" data-backdrop="true" data-keyboard="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div id="alertTitle" class="modal-header"
        style="background-color: #1a237e; color: #fff; font-size: 18px; font-weight: bold; padding: 10px 15px; margin: 0; border-radius: 0; border-bottom: none; position: relative;">
        <span id="alertTitleText" style="display: inline-block; color: #fff; text-transform: uppercase;">Title!</span>
        <button type="button" class="close" aria-label="Close" id="modalCloseBtn" (click)="closeModal()"
          style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); font-size: 28px; font-weight: bold; line-height: 1; color: #fff; opacity: 0.8; background: transparent; border: none; cursor: pointer; padding: 0; margin: 0; z-index: 1;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 0;">
        <div id="alertMessage" style="font-size: 14px; color: #f00; padding: 10px 15px; margin: 0;">
          Message..
        </div>
      </div>
    </div>
  </div>
</div>
<section>
  <div>
    <div class="inner-wrap">
      <p class="text-center">
        <img src="assets/modules/dummy-assets/common/img/GovEVA.png" alt="DigiCompany">
      </p>
      

      <form autocomplete="on" [formGroup]="loginForm">
        <div class="login-flow-card" *ngIf="!showCompanySelectionStep">
          <div class="flow-step-title">Screen 1 · Enter credentials</div>

          <div class="form-group">
            <label>E-mail address / Username:</label>
            <input [(ngModel)]="userName" #userInput (input)="onEmailChange()" (blur)="checkEmailValidity()" class="form-control"
              type="email" name="username" autocomplete="username" [formControl]="loginForm.controls['userName']">
            <div *ngIf="loginForm.controls['userName'].hasError('required') && loginForm.controls['userName'].touched"
              class="form-control-error-custom" style="text-align:left;">
              Email / Username is required.
            </div>
            <div *ngIf="loginForm.controls['userName'].hasError('email') && loginForm.controls['userName'].touched"
              class="form-control-error-custom" style="text-align:left;">
              Please enter a valid email address.
            </div>
          </div>

          <div class="form-group input-box">
            <label>Password:</label>
            <div id="fake-input" class="fake-input form-control"><span class="blinking-cursor"></span></div>
            <div class="password-wrapper">
              <input #passwordInput [type]="passwordVisible ? 'text' : 'password'" class="form-control" name="password" autocomplete="current-password"
                (focusin)="blinkCur()" (focusout)="blinkCurOut()" (keyup)="RemoveSavePassword()" (keyup.enter)="login()"
                [formControl]="loginForm.controls['password']">
              <i class="fa" [ngClass]="passwordVisible ? 'fa-eye' : 'fa-eye-slash'" (click)="togglePasswordVisibility()"
                (keydown.enter)="togglePasswordVisibility()" (keydown.space)="togglePasswordVisibility(); $event.preventDefault()"
                tabindex="0" role="button"></i>
            </div>
            <div *ngIf="loginForm.controls['password'].hasError('required') && loginForm.controls['password'].touched"
              class="form-control-error-custom" style="text-align:left">
              Password is required.
            </div>
          </div>

          <div class="text-center mb-2" *ngIf="!selectedCompanyId">
            <button class="btn btn-primary btn-block mr-2" type="button"
              [disabled]="!canProceedToCompanySelection() || companyFetchInProgress" (click)="continueToCompanySelection()">
              Verify credentials
            </button>
          </div>

          <!-- <div class="selected-company-note" *ngIf="selectedCompanyId">
            Company detected: <strong>{{ getSelectedCompanyName() }}</strong>
          </div> -->

          <div class="clearfix"></div>
          <div class="row" *ngIf="selectedCompanyId && companyConfig?.normalLogin">
            <div class="col" *ngIf="!environmentSettings.MfaLogin || userName === 'superadmin@gmail.com'">
              <div class="text-center">
                <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;"
                  [disabled]="!canLoginWithSelectedCompany() || LoginDisabled" [class.loading]="LoginDisabled" (click)="login() ">
                  <i aria-hidden="true"></i>Login
                </button>
              </div>
            </div>

            <div class="col" *ngIf="environmentSettings.MfaLogin && !(userName === 'superadmin@gmail.com')">
              <div class="text-center">
                <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;"
                  [disabled]="!canLoginWithSelectedCompany() || LoginDisabled" [class.loading]="LoginDisabled" (click)="login()"
                  [queryParams]="{returnUrl: redirectPath}">
                  <i aria-hidden="true"></i>Login (2Fa)
                </button>
              </div>
            </div>

            <div class="col" *ngIf="!environmentSettings.MfaLogin">
              <div class="text-center">
                <button class="btn btn-primary btn-block mr-2 mb-2" type="button" style="margin-top: 10px;"
                  [routerLink]="['/login-with-otp']" [queryParams]="{returnUrl: redirectPath}" [disabled]="!selectedCompanyId">
                  <i aria-hidden="true"></i>Login With OTP
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="!isADCompany" class="forgot-password-wrapper">
            <a class="forgot-password-link" [routerLink]="['/requestPassword']">Forgot Password?</a>
          </div>
        </div>

        <div class="login-flow-card" *ngIf="showCompanySelectionStep">
          <div class="flow-step-title">Screen 2 · Pick company</div>
          <div class="form-group">
            <label>Select your company:</label>
            <div class="company-list" *ngIf="!companyFetchInProgress && companyList.length">
              <button
                type="button"
                class="company-option-btn"
                *ngFor="let company of companyList"
                [class.active]="selectedCompanyId === company.value"
                (click)="selectedCompanyId = company.value; loginForm.controls['companyName'].setValue(company.value); companySelection(company.value)">
                <span class="company-option-name">{{ company.label }}</span>
                <span class="company-option-arrow">&rarr;</span>
              </button>
            </div>
            <div
              *ngIf="loginForm.controls['companyName'].hasError('required') && loginForm.controls['companyName'].touched && companyList.length"
              class="form-control-error-custom" style="text-align:left;">
              Company Name is required.
            </div>
            <small class="text-muted" *ngIf="companyFetchInProgress">Fetching your companies...</small>
            <small class="text-muted" *ngIf="!companyFetchInProgress && !companyList.length">{{ isEmailForCompany }}</small>
            <small class="text-muted" *ngIf="!companyFetchInProgress && companyList.length > 1">
              These credentials match {{ companyList.length }} companies.
            </small>
          </div>

          <div class="clearfix"></div>
          <div class="row" *ngIf="companyConfig?.normalLogin">
            <div class="col" *ngIf="!environmentSettings.MfaLogin || userName === 'superadmin@gmail.com'">
              <div class="text-center">
                <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;"
                  [disabled]="!canLoginWithSelectedCompany() || LoginDisabled" [class.loading]="LoginDisabled" (click)="login() ">
                  <i aria-hidden="true"></i>Login
                </button>
              </div>
            </div>

            <div class="col" *ngIf="environmentSettings.MfaLogin && !(userName === 'superadmin@gmail.com')">
              <div class="text-center">
                <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;"
                  [disabled]="!canLoginWithSelectedCompany() || LoginDisabled" [class.loading]="LoginDisabled" (click)="login()"
                  [queryParams]="{returnUrl: redirectPath}">
                  <i aria-hidden="true"></i>Login (2Fa)
                </button>
              </div>
            </div>

            <div class="col" *ngIf="!environmentSettings.MfaLogin">
              <div class="text-center">
                <button class="btn btn-primary btn-block mr-2 mb-2" type="button" style="margin-top: 10px;"
                  [routerLink]="['/login-with-otp']" [queryParams]="{returnUrl: redirectPath}" [disabled]="!showCompanySelectionStep">
                  <i aria-hidden="true"></i>Login With OTP
                </button>
              </div>
            </div>
          </div>

          <div class="text-center mt-2">
            <button type="button" class="back-link-btn" (click)="backToCredentialsStep()">
              <i class="fa fa-arrow-left mr-1"></i> Back
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
